<template>
  <div v-if="showStats" class="progressive-loader-overlay">
    <div class="progressive-loader-content">
      <div class="loader-header">
        <h5>Cargando Datos Progresivamente</h5>
        <p class="text-muted">
          Cargando mes {{ stats.currentMonth }}/{{ stats.currentYear }} 
          ({{ stats.current }} de {{ stats.total }} bloques)
        </p>
      </div>
      
      <div class="progress-container">
        <div class="progress-bar">
          <div 
            class="progress-fill" 
            :style="{ width: stats.percentage + '%' }"
          ></div>
        </div>
        <div class="progress-text">
          {{ stats.percentage }}% completado
        </div>
      </div>
      
      <div class="loader-details">
        <div class="detail-item">
          <span class="detail-label">Bloques procesados:</span>
          <span class="detail-value">{{ stats.current }}/{{ stats.total }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">Mes actual:</span>
          <span class="detail-value">{{ getMonthName(stats.currentMonth) }} {{ stats.currentYear }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">Tiempo estimado:</span>
          <span class="detail-value">{{ estimatedTimeLeft }}s restantes</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">Velocidad:</span>
          <span class="detail-value">{{ processingSpeed }} ms/mes</span>
        </div>
      </div>
      
      <div class="loader-actions">
        <b-button 
          variant="outline-secondary" 
          size="sm"
          @click="$emit('cancel')"
          :disabled="!allowCancel"
        >
          Cancelar
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue'

export default {
  name: 'ProgressiveStats',
  components: {
    BButton
  },
  props: {
    stats: {
      type: Object,
      default: () => ({
        current: 0,
        total: 0,
        percentage: 0,
        currentMonth: 0,
        currentYear: 0
      })
    },
    startTime: {
      type: Number,
      default: 0
    },
    allowCancel: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    showStats() {
      return this.stats.percentage > 0 && this.stats.percentage < 100
    },
    
    estimatedTimeLeft() {
      if (this.stats.current === 0) return 0
      
      const elapsed = Date.now() - this.startTime
      const avgTimePerMonth = elapsed / this.stats.current
      const remainingMonths = this.stats.total - this.stats.current
      
      return Math.round(avgTimePerMonth * remainingMonths / 1000)
    },
    
    processingSpeed() {
      if (this.stats.current === 0) return 0
      
      const elapsed = Date.now() - this.startTime
      return Math.round(elapsed / this.stats.current)
    }
  },
  methods: {
    getMonthName(month) {
      const months = [
        'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
        'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
      ]
      return months[month - 1] || ''
    }
  }
}
</script>

<style lang="scss" scoped>
.progressive-loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.progressive-loader-content {
  background: white;
  border-radius: 12px;
  padding: 2rem;
  max-width: 500px;
  width: 90%;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  text-align: center;
}

.loader-header {
  margin-bottom: 1.5rem;
  
  h5 {
    margin-bottom: 0.5rem;
    color: #333;
    font-weight: 600;
  }
  
  p {
    margin-bottom: 0;
    font-size: 0.9rem;
  }
}

.progress-container {
  margin-bottom: 1.5rem;
}

.progress-bar {
  width: 100%;
  height: 12px;
  background: #e9ecef;
  border-radius: 6px;
  overflow: hidden;
  margin-bottom: 0.5rem;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #007bff, #0056b3);
  border-radius: 6px;
  transition: width 0.3s ease;
  position: relative;
  
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
    animation: shimmer 2s infinite;
  }
}

@keyframes shimmer {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
}

.progress-text {
  font-size: 0.9rem;
  font-weight: 600;
  color: #007bff;
}

.loader-details {
  margin-bottom: 1.5rem;
  text-align: left;
}

.detail-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0;
  border-bottom: 1px solid #f0f0f0;
  
  &:last-child {
    border-bottom: none;
  }
}

.detail-label {
  font-size: 0.9rem;
  color: #666;
}

.detail-value {
  font-size: 0.9rem;
  font-weight: 600;
  color: #333;
}

.loader-actions {
  display: flex;
  justify-content: center;
  gap: 1rem;
}

// Responsive
@media (max-width: 576px) {
  .progressive-loader-content {
    padding: 1.5rem;
    margin: 1rem;
  }
  
  .loader-header h5 {
    font-size: 1.1rem;
  }
  
  .detail-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.25rem;
  }
}
</style> 